// extracted by mini-css-extract-plugin
export default {"BoxContainerWrapper":"BoxContainer_BoxContainerWrapper__hZ7hD","BoxContainer":"BoxContainer_BoxContainer__-9F2n"};